<p>admin-file-types works!</p>
